import { lazy } from "react";
import ClubsList from "../scenes/Pages/Configuration/Club/ClubsList";
import NewFinishTimesPage from "../scenes/Pages/RaceDay/Finish-Time-Entry-New";

const Club = lazy(() => import("../scenes/Pages/Configuration/Club/Club"));
const ScorePointEdit = lazy(() =>
  import("../scenes/Pages/Configuration/Score-Point-Defs/Edit/scorePointEdit")
);
const ScorePenalityEdit = lazy(() =>
  import("../scenes/Pages/Configuration/Score-Penality-Defs/ScorePenalityDefs")
);
const HCDefsEdit = lazy(() =>
  import("../scenes/Pages/Configuration/HcDefs/Edit/HcDefsEdit")
);
const EventSetup = lazy(() =>
  import("../scenes/Pages/Setup/Event-Setup/EventSetup")
);
const SeriesSetupKB = lazy(() =>
  import("../scenes/Pages/Setup/Series-Setup-KB/SeriesSetupKB")
);
const SeriesSetupOTB = lazy(() =>
  import("../scenes/Pages/Setup/Series-Setup-OTB/SeriesSetupOTB")
);
const RaceDays = lazy(() => import("../scenes/Pages/Setup/Race-Days/RaceDays"));
const KbEntrants = lazy(() =>
  import("../scenes/Pages/Entrants/KB-Entrants/KbEntrants")
);
const OtbEntrants = lazy(() =>
  import("../scenes/Pages/Entrants/OTB-Entrants/OtbEntrants")
);
const RaceSession = lazy(() =>
  import("../scenes/Pages/RaceDay/Race-Session/RaceSession")
);
const IndexResults = lazy(() =>
  import("../scenes/Pages/publicresults/IndexResults")
);
const RaceOverview = lazy(() =>
  import("../scenes/Pages/RaceDay/Race-Overview/RaceOverview")
);
const FinishTable2 = lazy(() =>
  import("../scenes/Pages/RaceDay/Finish-Time-Entry/ManualTimesEntryTab/FinishTable2")
);
const FinishRaceManager = lazy(() =>
  import("../scenes/Pages/RaceDay/Finish-Time-Entry/ManualTimesEntryTab/app_components_race-manager")
);
const StaticCustomTables = lazy(() =>
  import("../scenes/Pages/RaceDay/Finish-Time-Entry/StaticCustomTables")
);
const SharingRaceSessionData = lazy(() =>
  import(
    "../scenes/Pages/RaceDay/Sharing-Race-Session-Data/SharingRaceSessionData"
  )
);
const ReportsResult = lazy(() =>
  import("../scenes/Pages/Reports/Results/Results")
);
const PublishedResult = lazy(() =>
import("../scenes/Pages/Reports/PublishedResults/Results")
);
const Handicap = lazy(() =>
  import("../scenes/Pages/Reports/Handicap/Handicap")
);
const AddUser = lazy(() =>
  import("../scenes/Pages/Configuration/UserSetup/AddUser")
);
const UpdateUserProfile = lazy(() =>
  import("../scenes/Pages/Configuration/UserProfile/UpdateUserProfile")
);

const LayoutRoutes = [
  {
    path: "/configuration/club",
    component: <Club />,
  },
  {
    path: "/configuration/score-point-defs",
    component: <ScorePointEdit />,
  },
  {
    path: "/configuration/HcDefs",
    component: <HCDefsEdit />,
  },
  {
    path: "/configuration/score-penality-defs",
    component: <ScorePenalityEdit />,
  },
  {
    path: "/setup/event-setup",
    component: <EventSetup />,
  },
  {
    path: "/setup/series-setup-kb",
    component: <SeriesSetupKB />,
  },
  {
    path: "/setup/series-setup-otb",
    component: <SeriesSetupOTB />,
  },
  {
    path: "/setup/race-days",
    component: <RaceDays />,
  },
  {
    path: "/raceday/race-status",
    component: <RaceOverview />,
  },
  {
    path: "/raceday/race-session",
    component: <RaceSession />,
  },
  {
    path: "/entrants/kb-entrants",
    component: <KbEntrants />,
  },
  {
    path: "/entrants/otb-entrants",
    component: <OtbEntrants />,
  },
  {
    // old finsh time enty screen acccess
    path: "/raceday/finish-time-entry-old",
    component: <FinishRaceManager />,
  },
  {
    path: "/raceday/static-custom-tables",
    component: <StaticCustomTables />,
  },
  {
    path: "/raceday/sharing-race-session-data",
    component: <SharingRaceSessionData />,
  },
  {
    path: "/reports/result",
    component: <ReportsResult />,
  },
  {
	    path: "/reports/published-result",
	    component: <PublishedResult />,
  },
  {
    path: "/reports/handicap",
    component: <Handicap />,
  },
{
    path: "/raceday/FinishTable2",
    component: <FinishTable2 />,
},
{
  path: "/raceday/FinishRaceManager",
  component: <FinishRaceManager />,
},
{
  path: "/raceday/finish-time-entry",
  component: <NewFinishTimesPage />,
},
{
    path: "/publicresults/IndexResults",
    component: <IndexResults />,
  },  {
    path: "/configuration/AddUser",
    component: <AddUser />,
  },
  {
    path: "/configuration/UpdateUserProfile",
    component: <UpdateUserProfile />,
  },
{
  path: "/configuration/club/clubsList",
  component: <ClubsList />,
},
];

export default LayoutRoutes;
